<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Antrian Per Poli
                </h1>
            </div>
            <div class="w-full mt-5 text-center mb-5">
                <p class="font-poppins font-bold text-xl">
                    NAMA POLI: {{ poli.FS_NM_LAYANAN }}
                </p>
            </div>
            <div class="font-poppins mt-5">
                <p class="font-sm">
                    data diperbaharui pada :
                    <span class="text-red-500">{{ timerCount }}</span>
                </p>
            </div>
            <div class="w-full md:flex justify-center mt-5">
                <div
                    class="w-full md:w-1/2 md:grow mr-10"
                    v-if="tracingAntrianPoliData.left"
                >
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm">No Antri</th>
                                <th class="py-2 px-3 text-center text-sm">Nama</th>
                                <th class="py-2 px-3 text-center text-sm">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="data in tracingAntrianPoliData.left"
                                class="hover:bg-gray-100"
                            >
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.fn_no_urut }}
                                    </Link>
                                </td>
                                <td
                                    class="border-r border-t"
                                    :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                >
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.fs_nm_pasien }}
                                    </Link>
                                </td>
                                <td
                                    class="border-r border-t"
                                    :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                >
                                    <Link
                                    class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.status_antrian }}
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
                <div
                    class="w-full md:w-1/2 md:grow"
                    v-if="tracingAntrianPoliData.right"
                >
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm">No Antri</th>
                                <th class="py-2 px-3 text-center text-sm">Nama</th>
                                <th class="py-2 px-3 text-center text-sm">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="data in tracingAntrianPoliData.right"
                                class="hover:bg-gray-100"
                            >
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.fn_no_urut }}
                                    </Link>
                                </td>
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.fs_nm_pasien }}
                                    </Link>
                                </td>
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/antrian/${poli.FS_KD_LAYANAN}/${data.fn_no_urut}`"
                                    >
                                        {{ data.status_antrian }}
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
export default {
    data() {
        return {
            tracingAntrianPoliData: this.getInitalState(),
            timerCount: 10,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getAntrianPoliTracing();
                }
            },
            immediate: true,
        },
    },
    methods: {
        getAntrianPoliTracing() {
            this.$inertia.get(
                `/admin/antrian/${this.poli.FS_KD_LAYANAN}/ajax`,
                {},
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        var numberNow = 1;
                        var tracingDataTempLeft = [];
                        var tracingDataTempRight = [];
                        const tracingDataLength =
                            page.props.additional.tracingAntrianPoli.length;
                        if (tracingDataLength > 0) {
                            const perData = Math.ceil(tracingDataLength / 2);
                            page.props.additional.tracingAntrianPoli.forEach(
                                function (data) {
                                    if (data.fs_jam_checkin == "00:00:00") {
                                        data.status_antrian = "Belum Dilayani";
                                    }
                                    if (
                                        data.fs_jam_checkin != "00:00:00" &&
                                        data.fs_jam_masuk == "00:00:00"
                                    ) {
                                        data.status_antrian = "TTV - " + data.fs_jam_checkin;
                                    }
                                    if (
                                        data.fs_jam_checkin != "00:00:00" &&
                                        data.fs_jam_masuk != "00:00:00" &&
                                        data.fs_jam_keluar == "00:00:00"
                                    ) {
                                        data.status_antrian = "Sedang Dilayani";
                                    }
                                    if (
                                        data.fs_jam_checkin != "00:00:00" &&
                                        data.fs_jam_masuk != "00:00:00" &&
                                        data.fs_jam_keluar != "00:00:00"
                                    ) {
                                        if(data.fs_kd_selesai){
                                            data.status_antrian = "Selesai "+ data.ket_selesai;
                                        }else{
                                            data.status_antrian = "Selesai";
                                        }
                                    }

                                    if (data.fs_kd_selesai == 4) {
                                        data.status_antrian =
                                            "Tidak datang/batal";
                                    }

                                    if (numberNow <= perData) {
                                        tracingDataTempLeft.push(data);
                                    } else {
                                        tracingDataTempRight.push(data);
                                    }
                                    numberNow += 1;
                                }
                            );
                            this.tracingAntrianPoliData = {
                                left: tracingDataTempLeft,
                                right: tracingDataTempRight,
                            };
                        } else {
                            this.tracingAntrianPoli = {
                                left: "",
                                right: "",
                            };
                        }
                        this.timerCount = 10;
                    },
                }
            );
        },
        getInitalState() {
            var numberNow = 1;
            var tracingDataTempLeft = [];
            var tracingDataTempRight = [];
            const tracingDataLength = this.tracingAntrianPoli.length;
            if (tracingDataLength > 0) {
                const perData = Math.ceil(tracingDataLength / 2);
                this.tracingAntrianPoli.forEach(function (data) {
                    if (data.fs_jam_checkin == "00:00:00") {
                        data.status_antrian = "Belum Dilayani";
                    }
                    if (
                        data.fs_jam_checkin != "00:00:00" &&
                        data.fs_jam_masuk == "00:00:00"
                    ) {
                        data.status_antrian = "TTV - " + data.fs_jam_checkin;
                    }
                    if (
                        data.fs_jam_checkin != "00:00:00" &&
                        data.fs_jam_masuk != "00:00:00" &&
                        data.fs_jam_keluar == "00:00:00"
                    ) {
                        data.status_antrian = "Sedang Dilayani";
                    }
                    if (
                        data.fs_jam_checkin != "00:00:00" &&
                        data.fs_jam_masuk != "00:00:00" &&
                        data.fs_jam_keluar != "00:00:00"
                    ) {
                        if(data.fs_kd_selesai){
                            data.status_antrian = "Selesai "+ data.ket_selesai;
                        }else{
                            data.status_antrian = "Selesai";
                        }
                    }

                    if (data.fs_kd_selesai == 4) {
                        data.status_antrian = "Tidak datang/batal";
                    }

                    if (numberNow <= perData) {
                        tracingDataTempLeft.push(data);
                    } else {
                        tracingDataTempRight.push(data);
                    }
                    numberNow += 1;
                });
                return {
                    left: tracingDataTempLeft,
                    right: tracingDataTempRight,
                };
            } else {
                return {
                    left: "",
                    right: "",
                };
            }
        },
    },
    components: {
        Link,
        LayoutAdmin
    },
    props: {
        tracingAntrianPoli: Object,
        poli: Object,
    },
    layout: LayoutAdmin,
};
</script>
